import type { Candle } from './chart-data';
import type { Symbol } from './instruments';
import type { Timeframe } from './zone-math';

export type MarketSnapshot = { symbol: Symbol; tf: Timeframe; candles: Candle[]; fetchedAt: string; source?: string; priceType?: string; sessionOffsetMinutes?: number; latestCandleTime?: number };
const snapshots = new Map<string, MarketSnapshot>();
const key = (symbol: Symbol, tf: Timeframe) => symbol + ':' + tf;
export const readMarket = (symbol: Symbol, tf: Timeframe) => snapshots.get(key(symbol, tf)) || null;

// Session-only cache: switching back can paint immediately, while the normal
// background request still verifies fresh prices. No browser storage changes.
export function rememberMarket(next: MarketSnapshot) {
  const id = key(next.symbol, next.tf), previous = snapshots.get(id);
  const same = previous && previous.source === next.source && previous.sessionOffsetMinutes === next.sessionOffsetMinutes && previous.candles.length === next.candles.length && previous.candles.every((bar, i) => {
    const row = next.candles[i];
    return bar.time === row.time && bar.open === row.open && bar.high === row.high &&
      bar.low === row.low && bar.close === row.close && bar.volume === row.volume;
  });
  const value = same ? { ...next, candles: previous.candles } : next;
  snapshots.delete(id);
  snapshots.set(id, value);
  while (snapshots.size > 40) snapshots.delete(snapshots.keys().next().value!);
  return value;
}
